// Одна задача логисту на сделку из окна запроса в калькуляторе — та же схема, что у бота
// (routes/logisticsFromMessage.js, chooseTaskRouting) и у экрана товаров (ServicePage):
// товары группируются по проекту, побеждает проект с бо́льшим суммарным количеством,
// при равенстве — встретившийся первым. Остальные товары едут в той же задаче.
//
// Раньше окно создавало задачу на каждый товар — сделка 269809: три товара, три задачи.

const NO_PROJECT_KEY = '(без проекта)';

// Ключ группы — проект (GROUP_ID); без проекта — тег, чтобы товары без связки не слипались
// с чужими проектами.
function groupKeyOf(item) {
  if (item && item.groupId) return `project:${item.groupId}`;
  if (item && item.tagId) return `tag:${item.tagId}`;
  return NO_PROJECT_KEY;
}

/**
 * @param {Array<{groupId?:string, tagId?:string, quantity?:number|string}>} items
 * @returns {{ winner: object|null, items: Array }} winner — товар, чьи отдел/проект/тег/поток
 *   уходят в задачу; items — все товары, сначала победившая группа.
 */
export function orderItemsForSingleTask(items) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  if (list.length === 0) return { winner: null, items: [] };

  const groups = new Map();
  for (const item of list) {
    const key = groupKeyOf(item);
    if (!groups.has(key)) groups.set(key, { totalQty: 0, items: [] });
    const group = groups.get(key);
    group.totalQty += parseFloat(item.quantity) || 0;
    group.items.push(item);
  }

  let winningGroup = null;
  for (const group of groups.values()) {
    if (!winningGroup || group.totalQty > winningGroup.totalQty) winningGroup = group;
  }

  const others = list.filter((item) => !winningGroup.items.includes(item));
  return { winner: winningGroup.items[0], items: [...winningGroup.items, ...others] };
}
